<template lang='pug'>
  .fpui-helper.pointer
    i.fpui.fpui-ask(:class='className', v-tooltip="options")
</template>

<script>

export default {
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'blue'
    },
    position: {
      type: String,
      default: 'right-end'
    },
    type: {
      type: String
    },
    tooltipClass: {
      type: String
    }
  },
  computed: {
    options () {
      let ret = {
        content: this.text,
        html: true,
        placement: this.position,
        offset: 10,
        classes: []
      }
      if (this.type) ret.classes.push(this.type)
      if (this.tooltipClass) ret.classes.push(this.tooltipClass)
      return ret
    },
    className () {
      let className = [`text-${this.color}`]
      return className.join(' ')
    }
  }
}
</script>

<style lang='less'>
.fpui-helper {
  display: inline-block;
  margin-left: 10px;
}
</style>